import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

export interface SubSkillDescriptionDialogData {
  topic: string;
  description: string;
}

@Component({
  selector: 'app-sub-skill-description-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule],
  templateUrl: './sub-skill-description-dialog.component.html',
  styleUrls: ['./sub-skill-description-dialog.component.scss']
})
export class SubSkillDescriptionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SubSkillDescriptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SubSkillDescriptionDialogData
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
